import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import PostImg from "../../assets/post.png";

const Posts = () => {
  const navigate = useNavigate();
  const [activeCategory, setActiveCategory] = useState("All");

  const postsData = [
    {
      id: 1,
      title: "The Future of Technology: Innovations Shaping Our World",
      category: "Technology",
      views: "12.5M Views",
      date: "December 20, 2025",
      image: PostImg,
      content:
        "Technology is evolving at an unprecedented pace, reshaping industries and redefining the way we live and work...",
    },
    {
      id: 2,
      title: "Cloud Computing: Transforming Business Operations",
      category: "Cloud Services",
      views: "8.3M Views",
      date: "November 15, 2025",
      image: PostImg,
      content:
        "Cloud computing has revolutionized how businesses store, process, and manage data, offering scalability and flexibility...",
    },
    {
      id: 3,
      title: "Cybersecurity Best Practices for Small Businesses",
      category: "Security",
      views: "6.7M Views",
      date: "October 5, 2025",
      image: PostImg,
      content:
        "Small businesses are increasingly becoming targets for cyberattacks. Learn essential security measures to protect your data...",
    },
    {
      id: 4,
      title: "The Rise of Edge Computing in IoT Applications",
      category: "Technology",
      views: "5.2M Views",
      date: "September 18, 2025",
      image: PostImg,
      content:
        "Edge computing is changing how IoT devices process data, reducing latency and improving real-time analytics capabilities...",
    },
    {
      id: 5,
      title: "Data Center Sustainability: Green Initiatives",
      category: "Data Centers",
      views: "4.9M Views",
      date: "August 22, 2025",
      image: PostImg,
      content:
        "Modern data centers are implementing eco-friendly practices to reduce carbon footprints while maintaining performance...",
    },
    {
      id: 6,
      title: "Disaster Recovery Planning for the Digital Age",
      category: "Disaster Recovery",
      views: "3.8M Views",
      date: "July 10, 2025",
      image: PostImg,
      content:
        "Comprehensive disaster recovery strategies are essential for business continuity in today's technology-dependent world...",
    },
  ];

  const categories = [
    "All",
    "Technology",
    "Cloud Services",
    "Security",
    "Data Centers",
    "Disaster Recovery",
  ];

  const filteredPosts =
    activeCategory === "All"
      ? postsData
      : postsData.filter((post) => post.category === activeCategory);

  const handlePostClick = (post) => {
    navigate(`/blog/${post.id}`, { state: { post } });
  };

  return (
    <div className="text-white  pb-16">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h1 className="text-3xl md:text-4xl font-bold mb-4">Our Blog</h1>
          <p className="text-gray-300 max-w-2xl mx-auto">
            Stay updated with the latest trends, insights, and news in
            technology, cloud services, and IT solutions.
          </p>
        </div>

        {/* Category Filter */}
        <div className="flex flex-wrap justify-center gap-3 mb-10">
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => setActiveCategory(category)}
              className={`px-4 py-2 rounded-full text-sm transition-colors ${
                activeCategory === category
                  ? "bg-blue-600 text-white"
                  : "bg-[#050122] text-gray-300 hover:bg-gray-700"
              }`}
            >
              {category}
            </button>
          ))}
        </div>

        {/* Blog Posts Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
          {filteredPosts.map((post) => (
            <div
              key={post.id}
              className="bg-[#050122] rounded-lg overflow-hidden shadow-lg hover:shadow-2xl transition-shadow cursor-pointer"
              onClick={() => handlePostClick(post)}
            >
              <img
                src={post.image}
                alt={post.title}
                className="w-full h-48 object-cover"
              />
              <div className="p-6">
                <div className="flex justify-between items-center mb-3">
                  <span className="text-xs text-blue-400 font-semibold">
                    {post.category}
                  </span>
                  <span className="text-xs text-gray-400">{post.date}</span>
                </div>
                <h3 className="text-xl font-bold mb-3 line-clamp-2">
                  {post.title}
                </h3>
                <p className="text-gray-300 mb-4 line-clamp-3">
                  {post.content}
                </p>
                <div className="flex items-center justify-between">
                  <div className="flex items-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="text-gray-400 mr-2"
                    >
                      <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z"></path>
                      <circle cx="12" cy="12" r="3"></circle>
                    </svg>
                    <span className="text-gray-400 text-sm">{post.views}</span>
                  </div>
                  <span className="text-gray-400 text-sm"> {post.date}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Posts;
